import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useLocalizedState } from '@treams/treams-hooks';
import { AddIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import { Button, Input, Label, Modal, Popover } from '@treams/treams-ui';

export default function CreateEngagementTemplate(props: {
	onCreate: (template: graphql.EngagementTemplate) => void;
}) {
	const { t } = useTranslation();

	const [visible, setVisible] = useState(false);
	const [title, setTitle] = useState<graphql.LocalizedString>([]);
	const [localizedTitle, setLocalizedTitle] = useLocalizedState(title, setTitle);

	const [create] = graphql.useCreateEngagementTemplateMutation();

	return (
		<Popover.Target
			backdrop
			contents={
				<Modal width={400} height="auto">
					<Modal.Header title={t('settings.engagementLibrary.createTemplate.title')} />
					<Modal.Contents>
						<Label mb={2}>{t('settings.engagementLibrary.createTemplate.name.label')}:</Label>
						<Input value={localizedTitle} onChange={setLocalizedTitle} autoFocus />
					</Modal.Contents>
					<Modal.FormFooter
						onCancel={() => setVisible(false)}
						onSave={async () => {
							const response = await create({
								variables: {
									input: { title, interval: graphql.EngagementInterval.Weekly },
								},
							});
							props.onCreate(
								response.data!.createEngagementTemplate.template as graphql.EngagementTemplate,
							);
							setTitle([]);
							setVisible(false);
						}}
					/>
				</Modal>
			}
			visible={visible}
		>
			<Button
				type="primary"
				title={t('settings.engagementLibrary.createTemplate.button')}
				icon={<AddIcon />}
				onClick={() => setVisible(true)}
			/>
		</Popover.Target>
	);
}
